import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const syncOrder = {
  name: "syncOrder" as const,
  input: z.object({ orderId: zExt.objectId() }),
  output: z.object({ success: z.boolean() }),
};
